"use client";

import Image from "next/image";
import { Star } from "lucide-react";

interface Testimonial {
  id: number;
  name: string;
  role: string;
  company: string;
  image: string;
  rating: number;
  text: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Olive",
    role: "Dec 4, 2024",
    company: "",
    image: "/testimonials/olive.jpg",
    rating: 5,
    text: "I started at 58 score 😅 Got super helpful insights from YourWebsiteScore. Learned new things about SEO and Security I didn't know before and added them to my app 😊",
  },
  {
    id: 2,
    name: "David",
    role: "Dec 2, 2025",
    company: "",
    image: "/testimonials/david.jpg",
    rating: 5,
    text: "Thanks Andi for the great product!",
  },
  {
    id: 3,
    name: "Ashish",
    role: "Nov 18, 2025",
    company: "",
    image: "/testimonials/ashish.jpg",
    rating: 5,
    text: "And boom! Don't even take 5 mins. Typscool went from 🚨 to ✅!",
  },
  {
    id: 4,
    name: "Gaurav Tiwari",
    role: "Nov 17, 2025",
    company: "",
    image: "/testimonials/gaurav.jpg",
    rating: 5,
    text: "Cool built ✌️, my score was 55 for sketchidraw.com. It will surely help to make your websites better in all aspects.",
  },
  {
    id: 5,
    name: "Dr. Maen K Househ",
    role: "Nov 13, 2025",
    company: "",
    image: "/testimonials/househ.jpg",
    rating: 5,
    text: "Challenge accepted! Let's see up to what score we can push that. The score is already making much more sense than Google PageSpeed Insights",
  },
  {
    id: 6,
    name: "Aleksandar Jovanovic",
    role: "Nov 13, 2025",
    company: "",
    image: "/testimonials/aleksandar.jpg",
    rating: 5,
    text: "Guys, the late night pain paid off. The site is up and running again and the stats are looking better than ever! 😭😭😭 Check out YourWebsiteScore, it has helped me a lot!",
  },
  {
    id: 7,
    name: "Stu Green",
    role: "",
    company: "",
    image: "/testimonials/stu.jpg",
    rating: 5,
    text: 'I love the app. Just started using it. I like the "Copy to LLM" feature, and the fact the prompt is proprietary.',
  },
  {
    id: 8,
    name: "DOM",
    role: "Nov 9, 2025",
    company: "",
    image: "/testimonials/dom.jpg",
    rating: 5,
    text: "This tool is insane. Definitely worth paying for! Wasn't expecting a high score since it's still in the MVP stage but damn the trust needs to go up. At least I know now 😂",
  },
  {
    id: 15,
    name: "Rareș",
    role: "Jan 15, 2026",
    company: "",
    image: "/testimonials/rares.jpg",
    rating: 5,
    text: "YourWebsiteScore forced me to optimize my site for SEO, speed and security. My website is much better because of this product. I even reached a spot on the Leaderboard, which provides more visibility for my project :)",
  },
  {
    id: 9,
    name: "Jonah H.",
    role: "Nov 9, 2025",
    company: "",
    image: "/testimonials/jonah.jpg",
    rating: 5,
    text: "Gotta say, the LLM definitely works! I literally had a dream I had a score of straight 100s and was the 1st on the leaderboard. Woke up and well... definitely was a dream 😂",
  },
  {
    id: 10,
    name: "Pau Coderch",
    role: "",
    company: "",
    image: "/testimonials/pau.jpg",
    rating: 5,
    text: "Had some website optimizations pending. I used yourwebsitescore.com and it helped me catch what was actually broken - security issues, performance problems, stuff I didn't even notice. Went from a 69 score to 87. Very happy with the results :)",
  },
  {
    id: 12,
    name: "Luke",
    role: "Jan 6, 2026",
    company: "",
    image: "/testimonials/luke.jpg",
    rating: 5,
    text: "Deal of the decade was buying lifetime access.",
  },
  {
    id: 13,
    name: "Fons",
    role: "Jan 10, 2026",
    company: "",
    image: "/testimonials/fons.jpg",
    rating: 5,
    text: "Thanks Andi. I know what to work on now! Also congratulations on the flow, from login to scan to results. Smooth! It got the care it needed and feels frictionless.",
  },
  {
    id: 11,
    name: "Sam",
    role: "Sep 26, 2025",
    company: "",
    image: "/testimonials/sam.jpg",
    rating: 5,
    text: "In love with yourwebsitescore.com! Love grinding metrics before shipping!",
  },
  {
    id: 14,
    name: "Antonio Escudero",
    role: "Jan 14, 2026",
    company: "",
    image: "/testimonials/antonio.jpg",
    rating: 5,
    text: "YourWebsiteScore helped us improve SEO for RankInPublic.xyz. In under 20 seconds we found a couple of fundamental issues that were killing our reach. After fixing them, our organic traffic jumped, reaching more than 600 daily users. Straight to the point, no fluff, highly recommended product!",
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          className={`h-4 w-4 ${
            i < rating
              ? "fill-amber-400 text-amber-400"
              : "fill-muted text-muted"
          }`}
        />
      ))}
    </div>
  );
}

function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <div className="flex-shrink-0 w-[350px] sm:w-[400px] p-6 rounded-2xl border border-border/50 bg-card/50 backdrop-blur-sm">
      <div className="flex items-start gap-4">
        <Image
          src={testimonial.image}
          alt={testimonial.name}
          width={48}
          height={48}
          className="rounded-full object-cover"
          unoptimized
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <div>
              <p className="font-semibold text-foreground truncate">
                {testimonial.name}
              </p>
              <p className="text-xs text-muted-foreground truncate">
                {testimonial.role}
                {testimonial.company && ` @ ${testimonial.company}`}
              </p>
            </div>
            <StarRating rating={testimonial.rating} />
          </div>
        </div>
      </div>
      <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
        &ldquo;{testimonial.text}&rdquo;
      </p>
    </div>
  );
}

export function TestimonialsSection() {
  // Duplicate testimonials for seamless infinite scroll
  const allTestimonials = [...testimonials, ...testimonials];

  return (
    <section
      className="py-16 overflow-hidden relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen"
    >
      <div className="text-center mb-12 px-4">
        <div className="inline-flex items-center px-3 py-1 rounded-full border border-amber-500/50 mb-4">
          <span className="text-xs font-medium text-amber-500 uppercase tracking-wider">
            Testimonials
          </span>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-4">
          Loved by founders
          <span className="block text-amber-500">and SEO pros</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          See how users discover and fix critical website issues
        </p>
      </div>

      {/* Scrolling container - full width */}
      <div className="testimonials-container relative w-full">
        {/* First row - scrolls left */}
        <div
          className="testimonials-row-left flex gap-6 mb-6"
          style={{
            width: "fit-content",
          }}
        >
          {allTestimonials.map((testimonial, index) => (
            <TestimonialCard
              key={`row1-${testimonial.id}-${index}`}
              testimonial={testimonial}
            />
          ))}
        </div>

        {/* Second row - scrolls right */}
        <div
          className="testimonials-row-right flex gap-6"
          style={{
            width: "fit-content",
          }}
        >
          {[...allTestimonials].reverse().map((testimonial, index) => (
            <TestimonialCard
              key={`row2-${testimonial.id}-${index}`}
              testimonial={testimonial}
            />
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        @keyframes scroll-right {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }

        .testimonials-row-left {
          animation: scroll-left 80s linear infinite;
        }

        .testimonials-row-right {
          animation: scroll-right 80s linear infinite;
        }

        .testimonials-row-left:hover,
        .testimonials-row-right:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
